// API Configuration
// export const BASE_URL = "http://192.168.0.109:8000";
// export const BASE_URL = "http://localhost:8000";
// export const BASE_URL = "http://192.168.31.232:8000";
export const BASE_URL = "https://api.clinicalassist.ai/";
 